var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVulners = function SvgVulners(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 40,
    fill: "none",
    viewBox: "0 0 35 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#vulners_svg__a)",
    fillRule: "evenodd",
    d: "M16.238.355 1.306 8.987A2.6 2.6 0 0 0 0 11.241v17.518c0 .928.497 1.786 1.306 2.254l14.932 8.632a2.65 2.65 0 0 0 2.657-.004l14.807-8.627A2.6 2.6 0 0 0 35 28.765v-17.53c0-.925-.494-1.78-1.298-2.25L18.895.36a2.65 2.65 0 0 0-2.657-.004m-.026 7.618-8.188 4.733A2.6 2.6 0 0 0 6.72 14.96v9.642c0 .927.497 1.786 1.305 2.253l8.188 4.733a2.65 2.65 0 0 0 2.657-.004l8.114-4.728a2.6 2.6 0 0 0 1.298-2.249v-9.653c0-.925-.493-1.78-1.298-2.25L18.87 7.978a2.65 2.65 0 0 0-2.657-.004",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M27.921 25.924a2.6 2.6 0 0 0 .36-1.317V13.785l6.453-3.694a2.6 2.6 0 0 0-1.032-1.105L18.895.359a2.65 2.65 0 0 0-2.657-.004L1.305 8.987a2.6 2.6 0 0 0-1.037 1.105l6.45 3.693z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#38383A",
    fillRule: "evenodd",
    d: "M17.5 0c-.437.011-.872.13-1.262.355L1.305 8.987a2.6 2.6 0 0 0-1.037 1.105l6.45 3.693v10.817c0 .472.13.927.363 1.32L17.5 19.959z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vulners_svg__a",
    x1: 31.895,
    x2: -40.214,
    y1: 1.104,
    y2: 25.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })))));
};
export default SvgVulners;